/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import MobileNavbar from "./MobileNavbar";

export default MobileNavbar;
